<template>
    <div class="col-md-12 px-0 py-0">
        <div class="col-md-12">
            <div class="col-md-12 text-right text-success">
                <span style="font-size: 20px" v-text="title_section"></span>
            </div>
        </div>

        <form action="" method="post" class="form-horizontal mt-5">
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Titulo</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="title"
                        class="form-control"
                        placeholder="Titulo"
                    />
                    <span v-if="allerrors.title" :class="['show-error']">{{
                        allerrors.title[0]
                    }}</span>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Descripción</label
                >
                <div class="col-md-9">
                    <textarea
                        v-model="description"
                        class="form-control"
                        name="description"
                        rows="3"
                        placeholder="Descripción"
                    ></textarea>
                    <span
                        v-if="allerrors.description"
                        :class="['show-error']"
                        >{{ allerrors.description[0] }}</span
                    >
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Palabras claves</label
                >
                <div class="col-md-9">
                    <textarea
                        v-model="keyword"
                        class="form-control"
                        name="keyword"
                        rows="3"
                        placeholder="Palabras claves"
                    ></textarea>
                    <span v-if="allerrors.keyword" :class="['show-error']">{{
                        allerrors.keyword[0]
                    }}</span>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" @click="update()" class="btn btn-primary">
                    Actualizar
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: {
        url: String,
        parent_id: Number,
        title_section: {
            type: String,
            default: function () {
                return "SEO";
            },
        },
    },
    data() {
        return {
            action: null,
            title: null,
            description: null,
            keyword: null,
            allerrors: {
                title: null,
                description: null,
                keyword: null,
            },
        };
    },
    methods: {
        getModel() {
            let me = this;
            axios
                .get(me.action)
                .then(function (response) {
                    me.title = response.data.title;
                    me.description = response.data.description;
                    me.keyword = response.data.keyword;
                    me.clearError();
                })
                .catch(function (error) {});
        },
        update() {
            let me = this;
            if (me.validForm()) {
                axios
                    .put(me.action, {
                        title: me.title,
                        description: me.description,
                        keyword: me.keyword,
                    })
                    .then(function (response) {
                        me.clearError();
                        me.showActionSuccess();
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        validForm() {
            let me = this;
            let valid = true;

            if (!me.title) {
                me.allerrors.title = ["El campo título es obligatorio."];
                valid = false;
            } else if (me.title.length > 190) {
                me.allerrors.title = [
                    "El campo título debe tener máximo 190 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.title = null;
            }

            if (!me.description) {
                me.allerrors.description = [
                    "El campo descripción es obligatorio.",
                ];
                valid = false;
            } else if (me.description.length > 190) {
                me.allerrors.description = [
                    "El campo descripción debe tener máximo 190 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.description = null;
            }

            if (me.keyword.length > 190) {
                me.allerrors.keyword = [
                    "El campo palabras claves debe tener máximo 190 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.keyword = null;
            }
            return valid;
        },
        clearError() {
            let me = this;
            me.allerrors = {
                title: null,
                description: null,
                keyword: null,
            };
        },
        showActionSuccess() {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: "Actualizacion exitosa!",
            });
        },
    },
    mounted() {
        let me = this;
        const authUserId = document.querySelector(
            'meta[name="x-user"]'
        ).content;

        if (!me.parent_id == 0) {
            me.action = `${me.url}/${me.parent_id}?key=${authUserId}`;
        } else {
            me.action = `${me.url}?key=${authUserId}`;
        }
        me.getModel();
    },
};
</script>
<style>
.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}
</style>
